/**
 * Whether Nastavení kanceláře offers its „Šablony integrací“ item: to `master.integrations.manage`,
 * while the server says the office keeps integration templates. The flag alone decides.
 */
import { MasterAccountPermission } from '@insio/shared-types';
import { useMasterPermissions } from '@/features/auth';
import { useMasterAccountIntegrationTemplatesEnabled } from '@/features/master-account-integration-templates/hooks/use-master-account-integration-templates-enabled';
import type { OfficeMenuState } from './use-office-bridges-menu';

export function useOfficeIntegrationTemplatesMenuState(): OfficeMenuState {
  const { hasMasterPermission } = useMasterPermissions();
  const permitted = hasMasterPermission(MasterAccountPermission.INTEGRATIONS_MANAGE);
  const { enabled, loading } = useMasterAccountIntegrationTemplatesEnabled({ skip: !permitted });
  return { visible: permitted && enabled, loading: permitted && loading };
}

export function useOfficeIntegrationTemplatesMenu(): boolean {
  return useOfficeIntegrationTemplatesMenuState().visible;
}
